import type { ComponentType } from 'react';
import { PlatformAuditLogPage } from './PlatformAuditLogPage';
import { PlatformMetricsPage } from './PlatformMetricsPage';
import { PlatformOrganizationDetailPage } from './PlatformOrganizationDetailPage';
import { PlatformOrganizationsPage } from './PlatformOrganizationsPage';
import { PlatformUserDetailPage } from './PlatformUserDetailPage';
import { PlatformUsersPage } from './PlatformUsersPage';
import { PlatformWarnedTasksPage } from './PlatformWarnedTasksPage';

/**
 * PLATFORM YONETIMI EKRANLARININ KAYDI.
 *
 * Router'a DOKUNULMAZ: `src/app/screens.ts` bu iki sabiti icine alir
 * (`...adminScreens`, `admin: [...adminExtraRoutes.admin]`). Boylece feature'i
 * hayata gecirmek rota agacini degistirmeden mumkun oluyor ve birbirinden
 * bagimsiz feature'lar tek bir dosyada catismiyor.
 *
 * Anahtarlar `src/layout/menus.ts` icindeki MENU KIMLIKLERI. Yeni bir kimlik
 * uydurulamaz: menude olmayan bir kimlik hicbir zaman cizilmez.
 *
 * `admin.profile` BURADA YOK — o oge ortak profil ekranina bagli
 * (src/features/profile/screens.ts).
 */
export const adminScreens = {
  'admin.users': PlatformUsersPage,
  'admin.organizations': PlatformOrganizationsPage,
  'admin.metrics': PlatformMetricsPage,
  'admin.warnedTasks': PlatformWarnedTasksPage,
  'admin.auditLog': PlatformAuditLogPage,
} as const satisfies Readonly<Record<string, ComponentType>>;

/**
 * MENUDE GORUNMEYEN rotalar. Bolge guard'ini gruptan miras alirlar; bu
 * bolgeye zaten yalniz `super_admin` giriyor, ek bir yetki kisiti YOK
 * (buro yetki kodlari burada gecersiz — bkz. menus.ts).
 *
 * Detay ekranlari menude YER ALMAZ: bir kullanici/isletme secilmeden
 * anlamsizlar. Giris noktalari liste satirlaridir.
 */
export const adminExtraRoutes = {
  admin: [
    { path: '/yonetim/kullanicilar/:userId', component: PlatformUserDetailPage },
    { path: '/yonetim/isletmeler/:organizationId', component: PlatformOrganizationDetailPage },
  ],
} as const;
